import { ManageCms } from "apiEndPoints";
import { logger } from "utils";
import APIrequest from "../../axios";

// AdminManageCms contains functions to interact with the content management-related APIs for the admin module.
// Each function corresponds to a specific API endpoint for tasks such as fetching FAQs, updating terms and privacy, etc.

export const AdminManageCms = {
  /**
   * Function for fetching contact CMS content.
   * @returns {Promise<Object>} - A promise that resolves to the response from the contact CMS API.
   */
  contactCmsService: async () => {
    try {
      const payload = {
        ...ManageCms.contactUs,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  /**
   * Function for updating contact CMS content.
   * @param {Object} bodyData - Updated contact CMS information.
   * @returns {Promise<Object>} - A promise that resolves to the response from the update contact CMS API.
   */
  updateContactCmsService: async (bodyData) => {
    try {
      const payload = {
        ...ManageCms.updateContactUs,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  /**
   * Function for fetching terms and privacy content.
   * @param {string} id - ID of the terms and privacy content.
   * @returns {Promise<Object>} - A promise that resolves to the response from the get terms and privacy API.
   */
  getTermAndPrivacyService: async (id) => {
    try {
      const payload = {
        ...ManageCms.getCmsTermAndPrivacy(id),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  /**
   * Function for adding a new FAQ.
   * @param {Object} bodyData - New FAQ information.
   * @returns {Promise<Object>} - A promise that resolves to the response from the add FAQ API.
   */
  addFaq: async (bodyData) => {
    try {
      const payload = {
        ...ManageCms.addFaq,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  /**
   * Function for updating terms and privacy content.
   * @param {string} id - ID of the terms and privacy content.
   * @param {Object} bodyData - Updated terms and privacy information.
   * @returns {Promise<Object>} - A promise that resolves to the response from the update terms and privacy API.
   */
  updateTermAndPrivacyService: async (id, bodyData) => {
    try {
      const payload = {
        ...ManageCms.updateCmsTermAndPrivacy(id),
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  /**
   * Function for fetching FAQs.
   * @param {Object} queryParams - Query parameters for fetching FAQs.
   * @returns {Promise<Object>} - A promise that resolves to the response from the get FAQs API.
   */
  getFaq: async (queryParams) => {
    try {
      const payload = {
        ...ManageCms.getFaq,
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  /**
   * Function for deleting a FAQ.
   * @param {string} id - ID of the FAQ to be deleted.
   * @returns {Promise<Object>} - A promise that resolves to the response from the delete FAQ API.
   */
  deletefaq: async (id) => {
    try {
      const payload = {
        ...ManageCms.deleteFaq(id),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  /**
   * Function for fetching a single FAQ.
   * @param {string} id - ID of the FAQ to be fetched.
   * @returns {Promise<Object>} - A promise that resolves to the response from the get single FAQ API.
   */
  getSingleFAQsService: async (id) => {
    try {
      const payload = {
        ...ManageCms.getSingleFAQs(id),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  /**
   * Function for updating a FAQ.
   * @param {Object} bodyData - Updated FAQ information.
   * @param {string} id - ID of the FAQ to be updated.
   * @returns {Promise<Object>} - A promise that resolves to the response from the update FAQ API.
   */
  updateFAQsService: async (bodyData, id) => {
    try {
      const payload = {
        ...ManageCms.updateFAQ(id),
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

    /**
   * Function for Updating CMS content.
   * @param {string} id - ID of the CMS content.
   * @param {Object} bodyData - Updated CMS information.
   * @returns {Promise<Object>} - A promise that resolves to the response from the update CMS API.
   */
    updateCmsService: async ({ cmsPageId, bodyData }) => {
      try {
        const payload = {
          ...ManageCms.updateCms(cmsPageId),
          bodyData,
        };
        const res = await APIrequest(payload);
        return res;
      } catch (error) {
        logger(error);
        throw error;
      }
    },
  
    /**
     * Function for fetching CMS content.
     * @param {Object} queryParams - Query parameters for fetching CMS content.
     * @returns {Promise<Object>} - A promise that resolves to the response from the get CMS content API.
     */
    getSingleCms: async (id) => {
      try {
        const payload = {
          ...ManageCms.getSingleCms(id),
        };
        const res = await APIrequest(payload);
        return res;
      } catch (error) {
        logger(error);
        throw error;
      }
    },
};
